import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Observer, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-learning-center-third-section-input',
  templateUrl: './learning-center-third-section-input.component.html',
  styleUrls: ['./learning-center-third-section-input.component.scss']
})
export class LearningCenterThirdSectionInputComponent implements OnInit, OnDestroy {

  @Input() learningCenterForm: FormGroup;
  @Input() isEdit: boolean

  private originalForm: FormGroup;

  private content3ChangesSubscription: Subscription;

  loading: boolean = false;
  imageUrls: any[] = [];
  fileLists: NzUploadFile[][] = [];

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '150px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentArtical',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  constructor(private fb: FormBuilder, private messageService: NzMessageService) { }

  ngOnInit(): void {
    if (this.isEdit) {
      this.setImageFromForm();
      // Subscribe to changes in the CONTENT3 form array
    }
  }

  setImageFromForm(): void {
    const imagesArray = this.learningCenterForm.get('CONTENT3_IMAGE') as FormArray;

    this.imageUrls = imagesArray.controls.map(control => {
      return {
        imageUrl: control.get('IMAGE').value,
        dataStatus: 'original'
      }
    });
  }

  createFormArrayGroup(): FormGroup {
    return this.fb.group({
      CONTENT3_TITLE: ['', Validators.required],
      CONTENT3_DETAIL: ['', Validators.required],
      CONTENT3_IMAGE_PROFILE: ['', Validators.required],
      DATA_STATUS: ['add'] // assume 'add' by default
    });
  }

  createFormArrayGroupImage(): FormGroup {
    return this.fb.group({
      IMAGE: ['', Validators.required],
      IMAGE_DATA_STATUS: ['add'] // assume 'add' by default
    });
  }

  addContent3Group(): void {
    const activeGroups = this.content3Array.controls.filter(group => group.get('DATA_STATUS').value !== 'remove');
  
    if (activeGroups.length < 10) { // Limit the length of the array
      const group = this.createFormArrayGroup();
      const groupImage = this.createFormArrayGroupImage();
  
      (this.learningCenterForm.get('CONTENT3') as FormArray).push(group);
      (this.learningCenterForm.get('CONTENT3_IMAGE') as FormArray).push(groupImage);
    } else {
      this.messageService.error('สร้างได้สูงสุดแค่ 10 หัวข้อ', { nzDuration: 5000 });
    }
  }

  

  removeItem(index: number): void {
    const group = this.content3Array.at(index);
    const groupImage = this.content3ImageArray.at(index);

    group.get('DATA_STATUS').setValue('remove');
    groupImage.get('IMAGE_DATA_STATUS').setValue('remove');
    // this.imageUrls[index].dataStatus = 'remove';

    // Reset validation rules for the group if data status is 'remove'
    group.get('CONTENT3_TITLE').clearValidators();
    group.get('CONTENT3_TITLE').updateValueAndValidity();
    group.get('CONTENT3_DETAIL').clearValidators();
    group.get('CONTENT3_DETAIL').updateValueAndValidity();
    group.get('CONTENT3_IMAGE_PROFILE').clearValidators();
    group.get('CONTENT3_IMAGE_PROFILE').updateValueAndValidity();

    // Reset validation rules for the group if data status is 'remove'
    groupImage.get('IMAGE').clearValidators();
    groupImage.get('IMAGE').updateValueAndValidity();
  }

  countValid(index: number): number {
    let count = 0;
    for (let i = 0; i < index; i++) {
      if (this.content3Array.controls[i].get('DATA_STATUS').value !== 'remove') {
        count++;
      }
    }
    return count;
  }


  get content3Array(): FormArray {
    return this.learningCenterForm.get('CONTENT3') as FormArray;
  }

  get content3ImageArray(): FormArray {
    return this.learningCenterForm.get('CONTENT3_IMAGE') as FormArray;
  }

  // get content3Index(): number {
  //   // Return the index of the first form group that is not marked as 'remove'
  //   return this.content3Array.controls.findIndex(group => group.get('DATA_STATUS').value !== 'remove');
  // }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.messageService.error('รองรับเฉพาะไฟล์ .jpg และ .png เท่านั้น', { nzDuration: 5000 });
        observer.next(false);
        observer.complete();
        return;
      }
      const isLt5M = file.size! / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.messageService.error('รองรับไฟล์ขนาดไม่เกิน 5 mb', { nzDuration: 5000 });
        observer.next(false);
        observer.complete();
        return;
      }
      // Create a new Image object to load the file into it and check its dimensions
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => {
          const isWidthHeightValid = img.width === 100 && img.height === 100;
          if (!isWidthHeightValid) {
            this.messageService.warning('แนะนำให้ใช้รูปภาพขนาด 100x100 พิกเซล', { nzDuration: 5000 });
          }
          observer.next(isJpgOrPng && isLt5M);
          observer.complete();
        };
        img.onerror = () => {
          this.messageService.error('ไม่สามารถโหลดรูปภาพได้', { nzDuration: 5000 });
          observer.next(false);
          observer.complete();
        };
        // Set the img.src to the data URL
        img.src = reader.result as string;
      };
      // Read the file as a Data URL
      reader.readAsDataURL(file.originFileObj || file as any);
    });
  };
  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }, index: number): void {
    switch (info.file.status) {
      case 'uploading':

        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          this.imageUrls[index] = {
            imageUrl: img,
            dataStatus: 'add'
          }
        });
        this.fileLists[index] = []
        this.content3Array.at(index).get('CONTENT3_IMAGE_PROFILE')?.setValue(info.file.originFileObj.name);
        this.content3ImageArray.at(index).get('IMAGE')?.setValue(info.file.originFileObj);
        break;
      case 'error':

        this.loading = false;
        break;
    }
  }

  successRequest = ({ file, onSuccess, onError }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  ngOnDestroy(): void {
    // if (this.content3ChangesSubscription) {
    //   this.content3ChangesSubscription.unsubscribe();
    // }
  }

}
